import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getProviderWalletActions = providerId =>
  call(websocketFetch, 'get_provider_wallet_actions', {
    provider_id: providerId,
  });
